<template>
    <div id="kirmizi-santral-channel-detail">
        <AppBreadCrumb
            :paths="[{ title: 'Kırmızı Santral Channel Detail' }]"
            :select="true"
            class="visitor-detail-bread-crumb"
        >
        </AppBreadCrumb>

        <div class="route-page-content breadcrumb-content" v-if="channel">
            <SidebarChild
                :items="menuItems"
                :selected-item="currentTab"
                :focusActive="true"
                @selected="(i) => (currentTab = i.key)"
            />
            <div class="page-content-wrapper">
                <div class="toolbar">
                    <div class="left">
                        <IconButton :on-click="() => $router.push('/integrations/webphone/redsantral')">
                            <span class="material-icons"> chevron_left </span>
                        </IconButton>
                        <div class="icon-container">
                            <span class="material-icons" style="font-size: 30px; color: #d32f2f;">phone</span>
                        </div>
                        <div class="name">Kırmızı Santral Kanalı : {{ channel.name }}</div>
                    </div>
                    <div class="right">
                        <a-button type="danger" @click="deleteModal = true">
                            Kanalı Sil
                        </a-button>
                    </div>
                </div>

                <div v-if="currentTab === KirmiziSantralMenuTypes.MENU_TYPES.EXTENSIONS">
                    <KirmiziSantralExtensions v-model="channel" />
                </div>
                <div v-if="currentTab === KirmiziSantralMenuTypes.MENU_TYPES.EXTENSION_MAPPING">
                    <KirmiziSantralExtensionMapping v-model="channel" />
                </div>
                <div v-if="currentTab === KirmiziSantralMenuTypes.MENU_TYPES.WEBHOOKS">
                    <KirmiziSantralWebhooks v-model="channel" />
                </div>
                <div v-if="currentTab === KirmiziSantralMenuTypes.MENU_TYPES.CDR">
                    <KirmiziSantralCDR v-model="channel" />
                </div>
                <div v-if="currentTab === KirmiziSantralMenuTypes.MENU_TYPES.AUTOMATIONS">
                    <AutomationList type="event" module="webphone" />
                </div>
            </div>
        </div>

        <a-modal
            v-model="deleteModal"
            icon="exclamation-circle"
            :title="'Kırmızı Santral Kanalını Sil'"
            @cancel="deleteModal = false"
        >
            <p>Bu Kırmızı Santral kanalını silmek istediğinize emin misiniz?</p>
            <template #footer>
                <a-button key="back" @click="deleteModal = false">
                    Vazgeç
                </a-button>
                <a-button key="submit" type="danger" @click="deleteKirmiziSantralChannel">
                    Sil
                </a-button>
            </template>
        </a-modal>
    </div>
</template>

<script>
import Vue from "vue";
import IconButton from "../../../Settings/components/IconButton.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import _ from "lodash";
import log2 from "../../../../../utils/log2";
import KirmiziSantralMenuTypes from "./KirmiziSantralMenuTypes";
import AppBreadCrumb from "../../../../../components/common/AppBreadCrumb.vue";
import SidebarChild from "../../../../../components/Sidebar/SidebarChild.vue";
import KirmiziSantralExtensions from "./KirmiziSantralExtensions.vue";
import KirmiziSantralExtensionMapping from "./KirmiziSantralExtensionMapping.vue";
import KirmiziSantralWebhooks from "./KirmiziSantralWebhooks.vue";
import KirmiziSantralCDR from "./KirmiziSantralCDR.vue";
import AutomationList from "../../../Automation/pages/automations/AutomationList.vue";

const log = log2("KirmiziSantralChannelDetail.vue");

export default Vue.extend({
    name: "KirmiziSantralChannelDetail",
    components: {
        KirmiziSantralExtensions,
        KirmiziSantralExtensionMapping,
        KirmiziSantralWebhooks,
        KirmiziSantralCDR,
        IconButton,
        AppBreadCrumb,
        SidebarChild,
        AutomationList,
    },
    data() {
        const path = (_.last(this.$route.path.split("/")) || "extensions").toLowerCase().trim();
        const selected = KirmiziSantralMenuTypes.Items(this).find((x) => x.key === path);
        return {
            currentTab: selected ? selected.key : "extensions",
            loading: false,
            selectedChannelId: this.$route.params.id,
            deleteModal: false,
            channel: null,
            KirmiziSantralMenuTypes,
            menuItems: KirmiziSantralMenuTypes.Items(this),
        };
    },
    computed: {
        ...mapState({
            channels: (state) => state.channel.channels.filter((x) => x.type === "webphone-kirmizisantral"),
            siteId: (state) => _.get(state.site.site, "_id"),
            user: (state) => state.auth.user,
            site: (state) => state.site.site,
        }),
    },
    methods: {
        ...mapActions({
            createChannel: "channel/createChannel",
            listChannels: "channel/listChannels",
            deleteChannel: "channel/deleteChannel",
            updateChannel: "channel/updateChannel",
        }),
        changePage(page) {
            this.currentTab = page;
        },
        deleteKirmiziSantralChannel() {
            const channel = this.channel;
            this.deleteChannel(channel._id).then(() => {
                this.$router.push("/integrations/webphone/redsantral");
            });
        },
        handleSave() {
            const isValid = true;
            if (isValid) {
                const payload = this.channel;
                this.loading = true;
                this.updateChannel(payload)
                    .then(() => {
                        this.listChannels();
                        this.$message.success("Kanal başarıyla güncellendi");
                        this.$emit("ok");
                    })
                    .catch((err) => {
                        console.error(err);
                        this.$message.error("Kanal güncellenirken bir hata oluştu");
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
    },
    mounted() {
        this.listChannels().then((channels) => {
            this.channel = channels.find((x) => x._id === this.selectedChannelId);
            this.originalChannel = _.cloneDeep(this.channel);
        });
    },
    watch: {
        channel: {
            handler: function (val) {
                if (val) {
                    const isChanged = !_.isEqual(val, this.originalChannel);
                    if (isChanged) {
                        log("channel changed=>", val);
                        this.handleSave();
                    }
                }
            },
            deep: true,
        },
        currentTab(value) {
            const selected = this.menuItems.find((x) => x.key === value);
            if (selected) {
                this.$router.push(`/integrations/webphone/redsantral/${this.channel._id}/detail/${selected.key}`);
            }
        },
    },
});
</script>

<style scoped lang="scss">
#kirmizi-santral-channel-detail {
    display: flex;
    flex-direction: column;
    background: var(--color-bg-default);
    position: relative;
    width: 100%;
    height: 100%;

    .toolbar {
        padding: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 50px;
        border-bottom: 1px solid var(--color-border-default);

        .left {
            display: flex;
            align-items: center;
            gap: 5px;

            .name {
                font-size: 18px;
                font-weight: 700;
            }

            .icon-container {
                width: 30px;
                height: 30px;
                display: flex;
                margin: 0 auto;
                align-items: center;
                justify-content: center;
                border-radius: 6px;
                overflow: hidden;
                position: relative;
            }
        }

        .right {
            display: flex;
            justify-content: flex-end;
            gap: 5px;
        }
    }
}
</style> 